export enum PixelEvent {
  completeRegistration = 'CompleteRegistration',
}
